export default "/images/vendor/flag-icon-css/flags/1x1/kn.svg?2c6b3e41da7cf401967e6b4f5fd861ca";